import type { useHandleOrderFeedbackNotifications as useNativeHandleOrderFeedbackNotifications } from './useHandleOrderFeedbackNotifications';
import type { useOrderFeedbackNotifications as useNativeOrderFeedbackNotifications } from './useOrderFeedbackNotifications';

// ─────────────────────────────────────────────────────────────────────────────

const noop = async () => {};

const orderFeedbackNotifications = {
  scheduleOrderFeedbackNotification: noop,
  cancelScheduledOrderFeedbackNotification: noop,
};

export const useHandleOrderFeedbackNotifications: typeof useNativeHandleOrderFeedbackNotifications =
  () => {};

export const useOrderFeedbackNotifications: typeof useNativeOrderFeedbackNotifications = () =>
  orderFeedbackNotifications;
